import { styled } from "goober";
import { ClickButton } from "./ClickButton";
import { fieldOutline } from "./fieldOutline";

export const InlineInputForm = styled("form")`
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 240px;
  position: relative;
`;

export const InlineInput = styled("input")`
  padding: 12px 20px;
  padding-right: 40px;
  background: var(--surface-primary);
  color: var(--text-primary);
  ${fieldOutline("&:focus")}
  border-radius: 9999px;
  border: 0;
  font-size: 12px;
  font-family: InterVariable;
  font-weight: 450;
  line-height: 16px;
  width: 100%;
  min-width: 240px;

  &::placeholder {
    opacity: 0.3;
  }

  &:focus {
    &::placeholder {
      opacity: 0.6;
    }
  }
`;

export const InlineInputButton = styled(ClickButton)`
  position: absolute;
  right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 9999px;
  background: transparent;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0;

  &:hover:not(:disabled) {
    background: var(--surface-hover);
    color: var(--text-primary);
  }

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }
`;
